import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgencySMWWDifference.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const AgencySMWWDifference = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
        setIsLoading(false);
        })
        
    },[]);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className="smww-difference-main">
                    <Helmet><title>SMWW Difference</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="smww-difference-container">
                            <h1>The SMWW Difference</h1>

                            <p><em>Dear Athlete,</em></p>

                            <p><em><img alt="lashbrook" className="img_right" src="/basic/web/images/agent/lashbrook.gif" />After working for years in a corporate sports agency and representing over 20 NFL Clients I came to the conclusion that it is virtually impossible for one agent to adequately service and mentor each client to the level that they deserve and expect while recruiting next years prospects. With this experience and my passion as an educator to help others, I created Sports Management Worldwide to train a new generation of agents.</em></p>

                            <p><em>Sports Management Worldwide Agency prides itself on being different from other agencies. We have Agent Advisors who have gone thru a rigorous training program here at SMWW. They have been tested and retested and selected to represent SMWW athletes. Weekly, my staff and faculty, personally meet with the Agent Advisors&nbsp;to keep them apprised of ongoing changes in this industry and to provide you with the best possible representation.</em></p>

                            <p><em>SMWW Agent Advisors can individually deal with your day to day issues and challenges that athletes face during their professional careers. In addition, SMWW Staff and Strategic Alliances offer SMWW Agent Advisors the expertise, experience, credentials, and guidance as needed around the clock. We assist our clients via the Agent Advisor to reach their goals, plan for the future, and take care of daily issues. We help our clients on and off the field, court, rink, track and pitch, to succeed in their career and post-career. This level of expertise and "one on one" attention cannot be surpassed by any other "super agency" or individual agent.</em></p>

                            <p><em>Being a professional athlete can be a great experience and is a unique opportunity for fame and fortune. It is important that every athlete has the right advice, guidance, and counsel to make the most of this opportunity. Sports Management Worldwide Agency can provide that service.</em></p>

                            <p><em>Please feel free to visit our list of </em><a href="/sports_agents_map">Agent Advisors</a><em> located throughout the world, who represent athletes in a variety of sports.</em></p>

                            <div>&nbsp;</div>

                            <p><em>Sincerely,</em></p>

                            <p><strong>Dr. G. Lynn Lashbrook</strong><br />
                            President and Founder<br />
                            Sports Management Worldwide</p>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default AgencySMWWDifference;